import { NewsWrapper } from "../../../../src/collections/news/News.style.js";
import SIG_network from "../../../../src/collections/news/2019/2019-11-23-cncf-sig-network-set-to-push-cloud-native-networking-forward/SIG-network-367x200.webp";
import * as React from 'react';
export default {
  NewsWrapper,
  SIG_network,
  React
};